import React, { useContext, useEffect, useMemo, useState } from "react";
import { Badge, Button, Form, Modal, Table } from "react-bootstrap";
import { FaRedoAlt, FaRupeeSign, FaSearch, FaUniversity, FaUsers } from "react-icons/fa";
import { GlobalContext } from "../../Context/GlobalState";
import swal from "sweetalert";

const packkySettlementAuth = {
  username: "packky@gmail.com",
  password: "Z90LTO34RTNQGT49LCIYRVTXJERZTKX8",
};

const formatApiDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const getPreviousWeekRange = () => {
  const today = new Date();
  const previousSunday = new Date(today);
  previousSunday.setDate(today.getDate() - (today.getDay() === 0 ? 7 : today.getDay()));

  const previousMonday = new Date(previousSunday);
  previousMonday.setDate(previousSunday.getDate() - 6);

  return {
    fromDate: formatApiDate(previousMonday),
    toDate: formatApiDate(previousSunday),
  };
};

const Packkysettleamountwidgetvolunteer = () => {
  const [settlementData, setSettlementData] = useState([]);
  const [fromDate, setFromDate] = useState(
    () => getPreviousWeekRange().fromDate
  );
  const [toDate, setToDate] = useState(() => getPreviousWeekRange().toDate);
  const [searchTerm, setSearchTerm] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [clickedRows, setClickedRows] = useState([]);
  const [statusUpdatingRows, setStatusUpdatingRows] = useState([]);
  const [beneficiaryUpdatingRows, setBeneficiaryUpdatingRows] = useState([]);
  const [statusModal, setStatusModal] = useState({
    show: false,
    item: null,
    status: "N",
    remarks: "",
  });
  const { setTransactionLoaderState } = useContext(GlobalContext);
  const { username, password } = packkySettlementAuth;
  const [yesBankBalance, setYesBankBalance] = useState(null);
  const [isBalanceLoading, setIsBalanceLoading] = useState(false);
  const formatAmount = (value) =>
    Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const getStatusBadge = (status) => {
    if (status === "Y") {
      return (
        <Badge bg="success" style={{ borderRadius: "999px", padding: "6px 10px" }}>
          Settled
        </Badge>
      );
    }

    return (
      <Badge bg="warning" text="dark" style={{ borderRadius: "999px", padding: "6px 10px" }}>
        Pending
      </Badge>
    );
  };

  const filteredSettlementData = settlementData.filter((item) => {
    const searchText = `${item.volunteer_code || ""} ${item.volunteer_id || ""} ${
      item.bank_name || ""
    } ${item.bank_holder_name || ""} ${item.account_no || ""} ${
      item.ifsc_code || ""
    }`.toLowerCase();

    return searchText.includes(searchTerm.toLowerCase());
  });

  const totalAmount = useMemo(
    () =>
      settlementData.reduce(
        (sum, item) => sum + Number(item.total_amount || 0),
        0
      ),
    [settlementData]
  );
  const pendingCount = settlementData.filter((item) => item.status === "N").length;
  const settledCount = settlementData.filter((item) => item.status === "Y").length;

  const fetchPackkySettlementAmount = async (
    selectedFromDate = fromDate,
    selectedToDate = toDate
  ) => {
    setTransactionLoaderState(true);
    setErrorMessage("");

    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fromDate: selectedFromDate,
          toDate: selectedToDate,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        "https://api2.packky.com/api/VolunteerAdmin/v1.0/getVolunteerSettlementAmount",
        requestOptions
      );
      const data = await res.json();
      const requestData = data.response?.request;

      if (data.responseCode === "00" && Array.isArray(requestData)) {
        setSettlementData(requestData);
      } else {
        setSettlementData([]);
        setErrorMessage(data.responseMessage || "Failed to fetch settlement data");
      }
    } catch (error) {
      console.log("error", error);
      setSettlementData([]);
      setErrorMessage("Something went wrong while fetching settlement data");
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const handleFilterSubmit = (event) => {
    event.preventDefault();
    fetchPackkySettlementAmount(fromDate, toDate);
  };

  const updatePackkySettlementStatus = async (driverId) => {
    const base64Credentials = btoa(`${username}:${password}`);
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Basic ${base64Credentials}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        volunteerId: driverId?.toString(),
        fromDate,
        toDate,
      }),
      redirect: "follow",
    };

    const response = await fetch(
      "https://api2.packky.com/api/VolunteerAdmin/v1.0/updateVolunteerSettlementStatus",
      requestOptions
    );
    return response.json();
  };

  const revertBackPackkySettlementStatus = async (
    driverId,
    selectedStatus,
    remarks
  ) => {
    const base64Credentials = btoa(`${username}:${password}`);
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Basic ${base64Credentials}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fromDate,
        toDate,
        status: selectedStatus,
        volunteerId: driverId?.toString(),
        remarks,
      }),
      redirect: "follow",
    };

    const response = await fetch(
      "https://api2.packky.com/api/VolunteerAdmin/v1.0/revertVolunteerBackSettlementStatus",
      requestOptions
    );
    return response.json();
  };

  const handleAddBeneficiary = async (item) => {
    const rowId = item.volunteer_id || item.volunteer_code;

    setBeneficiaryUpdatingRows((prev) => [...prev, rowId]);
    setTransactionLoaderState(true);

    try {
      const yesPayResponse = await fetch(
        "https://api.anlook.com/api/yespay/add-beneficiary",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
           
            bankName: item.bank_name,
            ifscCode: item.ifsc_code,
            beneAccountNo: item.account_no,
            beneName: item.bank_holder_name,
          }),
        }
      );
      const yesPayResult = await yesPayResponse.json();

      if (
        !yesPayResponse.ok ||
        yesPayResult.statusCode !== 200 ||
        !yesPayResult.beneficiaryCd
      ) {
        swal(
          "Error",
          yesPayResult.message ||
            yesPayResult.responseMessage ||
            "Failed to add beneficiary in YesPay",
          "error"
        );
        return;
      }
      const confirmedBeneficiaryCode = yesPayResult.beneficiaryCd;

      const base64Credentials = btoa(`${username}:${password}`);
      const response = await fetch(
        "https://api2.packky.com/api/Admin/v1.0/insertDriverBeneficiaryCode",
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json-patch+json",
          },
          body: JSON.stringify({
            driverId: item.volunteer_id?.toString(),
            accountNumber: item.account_no,
            beneficiaryCode: confirmedBeneficiaryCode,
            status: "Y",
          }),
        }
      );
      const result = await response.json();

      if (result.responseCode === "00") {
        await fetchPackkySettlementAmount(fromDate, toDate);
        swal(
          "Success",
          result.responseMessage || "Beneficiary Code Added Successfully",
          "success"
        );
      } else {
        swal(
          "Error",
          result.responseMessage || "Failed to add beneficiary code",
          "error"
        );
      }
    } catch (error) {
      swal("API call failed", "An error occurred", "error");
    } finally {
      setBeneficiaryUpdatingRows((prev) =>
        prev.filter((id) => id !== rowId)
      );
      setTransactionLoaderState(false);
    }
  };

  const openStatusModal = (item) => {
    setStatusModal({
      show: true,
      item,
      status: item.status || "N",
      remarks: "",
    });
  };

  const closeStatusModal = () => {
    setStatusModal({
      show: false,
      item: null,
      status: "N",
      remarks: "",
    });
  };

  const handleSettlementStatusChange = async (event) => {
    event.preventDefault();

    const { item, status: selectedStatus, remarks } = statusModal;
    if (!item) return;

    const rowId = item.volunteer_id || item.volunteer_code;

    if (!rowId) return;

    if (selectedStatus === item.status) {
      swal("Info", "Please select a different status", "info");
      return;
    }

    if (!remarks.trim()) {
      swal("Error", "Remarks are required", "error");
      return;
    }

    setStatusUpdatingRows((prev) => [...prev, rowId]);
    setTransactionLoaderState(true);

    try {
      const result = await revertBackPackkySettlementStatus(
        rowId,
        selectedStatus,
        remarks
      );

      if (result.responseCode === "00") {
        swal(
          "Success",
          result.responseMessage || "Settlement status changed successfully",
          "success"
        );
        setSettlementData((prev) =>
          prev.map((row) =>
            (row.volunteer_id || row.volunteer_code) === rowId
              ? { ...row, status: selectedStatus }
              : row
          )
        );
        if (selectedStatus === "N") {
          setClickedRows((prev) => prev.filter((id) => id !== rowId));
        }
        closeStatusModal();
      } else {
        swal(
          "Error",
          result.responseMessage || "Failed to change settlement status",
          "error"
        );
      }
    } catch (error) {
      swal("API call failed", "An error occurred", "error");
    } finally {
      setStatusUpdatingRows((prev) => prev.filter((id) => id !== rowId));
      setTransactionLoaderState(false);
    }
  };

  const handleProcessAll = async (item) => {
    const rowId = item.volunteer_id || item.volunteer_code;

    if (clickedRows.includes(rowId)) {
      swal("Error", "Button already clicked for this row", "error");
      return;
    }

    const sanitize = (value) =>
      typeof value === "string" ? value.trim() : value;

    if (
      !item.account_no ||
      !item.ifsc_code ||
      !item.bank_holder_name ||
      !item.beneficiary_id
    ) {
      swal(
        "Error",
        "Bank account, IFSC, holder name, and beneficiary code are required.",
        "error"
      );
      return;
    }

    setTransactionLoaderState(true);

    try {
      const base64Credentials = btoa("anlook@gmail.com:Anlook@12345");

      const payload = {
        id: rowId?.toString(),
        isVolunteer: "Y",
        fromDate,
        toDate,
        p1_Account: sanitize(item.account_no),
        p2_ifsccode: sanitize(item.ifsc_code),
        p3_mode: "IMPS",
        p4_amount: item.total_amount?.toString(),
        p5_customername: sanitize(item.bank_holder_name),
        p6_refrence_id: (item.volunteer_code || rowId)?.toString(),
        p7_emailid: item.email_id || item.email || "",
        p8_phoneno: item.mobile || item.phone || "",
        p9_beneCode: item.beneficiary_id,
      };

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      };

      // Previous API:
      // `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/SalaryManagement/ChaafoPayroll`
      console.log("Chaafo volunteer payout payload:", payload);

      const response = await fetch(
        "https://api.anlook.com/api/Transactions/v1.0/chaafoPayoutProccess",
        requestOptions
      );

      const result = await response.json();
      if (
        response.ok &&
        (result.responseCode === "00" ||
          result.statusCode === 200 ||
          result.status === "0")
      ) {
        const updateResult = await updatePackkySettlementStatus(item.volunteer_id);

        if (updateResult.responseCode !== "00") {
          swal(
            "Warning",
            updateResult.responseMessage ||
              "Amount transferred, but settlement status update failed.",
            "warning"
          );
          return;
        }

        swal(
          "Success",
          result.responseMessage ||
            result.data?.message ||
            result.msg ||
            "Amount Transfer Successfully",
          "success"
        );
        setSettlementData((prev) =>
          prev.map((row) =>
            (row.volunteer_id || row.volunteer_code) === rowId
              ? { ...row, status: "Y" }
              : row
          )
        );
        setClickedRows((prev) => [...prev, rowId]);
      } else {
        swal(
          "Error",
          result.message || result.responseMessage || result.msg || "Payout failed",
          "error"
        );
      }
    } catch (error) {
      swal("API call failed", "An error occurred", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const fetchYesBankBalance = async () => {
    setIsBalanceLoading(true);

    try {
      const response = await fetch(
        "https://payin.remittpe.com/api/Payout/YesBank/GetBalance",
        {
          method: "GET",
          headers: {
            Accept: "*/*",
          },
        }
      );
      const result = await response.json();

      if (response.ok && result.responseCode === "00") {
        setYesBankBalance(result.data?.clearBalance ?? null);
      } else {
        swal(
          "Error",
          result.responseMessage || "Failed to fetch Yes Bank balance",
          "error"
        );
      }
    } catch (error) {
      swal("API call failed", "Unable to fetch Yes Bank balance", "error");
    } finally {
      setIsBalanceLoading(false);
    }
  };
  useEffect(() => {
    const previousWeek = getPreviousWeekRange();
    fetchPackkySettlementAmount(previousWeek.fromDate, previousWeek.toDate);
  }, []);

  return (
    <>
      <div>
        <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap">
          <div>
            <h5 className="mb-1" style={{ color: "#24313f", fontWeight: 700 }}>
              Packky Volunteers Settlement Details
            </h5>
          </div>
          <div className="d-flex align-items-center" style={{ gap: ".75rem" }}>
                    <Button
                      size="sm"
                      variant="light"
                      onClick={fetchYesBankBalance}
                      disabled={isBalanceLoading}
                      style={{
                        border: "1px solid #cddfdc",
                        borderRadius: ".5rem",
                        color: "#0f766e",
                        fontWeight: 600,
                        background: "#f0fdfa",
                      }}
                    >
                      <FaRedoAlt className={`mr-1${isBalanceLoading ? " fa-spin" : ""}`} />{" "}
                      {isBalanceLoading ? "Refreshing..." : "Refresh"}
                    </Button>
                    <span style={{ color: "#0f766e", fontWeight: 700 }}>
                      Balance: {yesBankBalance === null ? "--" : `Rs. ${formatAmount(yesBankBalance)}`}
                    </span>
                  </div>
        </div>

        <div className="row">
          <div className="col-md-4 mb-2">
            <div
              className="p-3 h-100"
              style={{
                background: "#ffffff",
                border: "1px solid #e7d9c7",
                borderTop: "4px solid #4f46e5",
                borderRadius: ".75rem",
                boxShadow: "0 10px 24px rgba(36, 49, 63, 0.06)",
              }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="text-muted" style={{ fontSize: ".78rem", fontWeight: 600 }}>
                    Total Drivers
                  </div>
                  <h4 className="mb-0 mt-1" style={{ fontWeight: 800, color: "#24313f" }}>
                    {settlementData.length}
                  </h4>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "46px",
                    height: "46px",
                    borderRadius: "50%",
                    background: "#eef2ff",
                    color: "#4f46e5",
                    fontSize: "1.15rem",
                  }}
                >
                  <FaUsers />
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-2">
            <div
              className="p-3 h-100"
              style={{
                background: "#ffffff",
                border: "1px solid #e7d9c7",
                borderTop: "4px solid #059669",
                borderRadius: ".75rem",
                boxShadow: "0 10px 24px rgba(36, 49, 63, 0.06)",
              }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="text-muted" style={{ fontSize: ".78rem", fontWeight: 600 }}>
                    Total Amount
                  </div>
                  <h4 className="mb-0 mt-1" style={{ fontWeight: 800, color: "#24313f" }}>
                    Rs. {formatAmount(totalAmount)}
                  </h4>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "46px",
                    height: "46px",
                    borderRadius: "50%",
                    background: "#ecfdf5",
                    color: "#059669",
                    fontSize: "1.15rem",
                  }}
                >
                  <FaRupeeSign />
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-2">
            <div
              className="p-3 h-100"
              style={{
                background: "#ffffff",
                border: "1px solid #e7d9c7",
                borderTop: "4px solid #d97706",
                borderRadius: ".75rem",
                boxShadow: "0 10px 24px rgba(36, 49, 63, 0.06)",
              }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="text-muted" style={{ fontSize: ".78rem", fontWeight: 600 }}>
                    Pending / Settled
                  </div>
                  <h4 className="mb-0 mt-1" style={{ fontWeight: 800, color: "#24313f" }}>
                    {pendingCount} / {settledCount}
                  </h4>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "46px",
                    height: "46px",
                    borderRadius: "50%",
                    background: "#fff7ed",
                    color: "#d97706",
                    fontSize: "1.15rem",
                  }}
                >
                  <FaUniversity />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Form
          onSubmit={handleFilterSubmit}
          className="d-flex justify-content-between align-items-end mb-3 flex-wrap"
          style={{ gap: ".75rem" }}
        >
          <div className="d-flex align-items-end flex-wrap" style={{ gap: ".5rem" }}>
            <Form.Group>
              <Form.Label style={{ fontSize: ".8rem", fontWeight: 700, color: "#5f5347" }}>
                From Date
              </Form.Label>
              <Form.Control
                size="sm"
                type="date"
                value={fromDate}
                max={toDate}
                onChange={(event) => setFromDate(event.target.value)}
                style={{ border: "1px solid #d8cec0", height: "2.15rem" }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label style={{ fontSize: ".8rem", fontWeight: 700, color: "#5f5347" }}>
                To Date
              </Form.Label>
              <Form.Control
                size="sm"
                type="date"
                value={toDate}
                min={fromDate}
                onChange={(event) => setToDate(event.target.value)}
                style={{ border: "1px solid #d8cec0", height: "2.15rem" }}
              />
            </Form.Group>
            <Button
              size="sm"
              type="submit"
              style={{
                height: "2.15rem",
                borderRadius: ".45rem",
                fontWeight: 700,
                background: "#0f766e",
                borderColor: "#0f766e",
              }}
            >
              Apply
            </Button>
          </div>

          <div className="position-relative" style={{ width: "min(100%, 20rem)" }}>
            <FaSearch
              style={{
                position: "absolute",
                left: ".75rem",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#9a8f80",
                fontSize: ".85rem",
              }}
            />
            <Form.Control
              size="sm"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search driver, bank, account"
              style={{
                borderRadius: "999px",
                border: "1px solid #d8cec0",
                paddingLeft: "2rem",
                height: "2.15rem",
                background: "#ffffff",
              }}
            />
          </div>
        </Form>

        {errorMessage && (
          <div className="alert alert-danger py-2" style={{ fontSize: ".9rem" }}>
            {errorMessage}
          </div>
        )}

        <div
          style={{
            background: "#ffffff",
            border: "1px solid #eee3d3",
            borderRadius: ".65rem",
            overflow: "hidden",
          }}
        >
          <Table hover responsive size="sm" className="mb-0">
            <thead>
              <tr style={{ background: "#f6f0e8" }}>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  #
                </th>
                <th style={{ border: "none", color: "#5f5347" }}>Driver</th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Amount
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Bank Details
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  IFSC
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Period
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Status
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Change Status
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredSettlementData.length > 0 ? (
                filteredSettlementData.map((item, index) => (
                  <tr key={`${item.volunteer_id || item.volunteer_code}-${index}`}>
                    <td className="text-center align-middle">{index + 1}</td>
                    <td className="align-middle">
                      <div style={{ fontWeight: 700, color: "#24313f", fontSize: ".9rem" }}>
                        {item.bank_holder_name || "-"}
                      </div>
                      <span className="text-muted" style={{ fontSize: ".8rem" }}>
                        {item.volunteer_code || "-"} | ID: {item.volunteer_id || "-"}
                      </span>
                    </td>
                    <td className="text-center align-middle" style={{ fontWeight: 700 }}>
                      Rs. {formatAmount(item.total_amount)}
                    </td>
                    <td className="text-center align-middle" style={{ fontSize: ".9rem" }}>
                      <div>{item.bank_name || "-"}</div>
                      <span className="text-muted" style={{ fontSize: ".8rem" }}>
                        {item.account_no || "-"}
                      </span>
                    </td>
                    <td className="text-center align-middle" style={{ fontSize: ".9rem" }}>
                      {item.ifsc_code || "-"}
                      <br />
                      {item.beneficiary_id ? (
                        <span
                          style={{
                            display: "inline-block",
                            marginTop: "4px",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            background: "#fff3cd",
                            color: "#856404",
                            fontSize: ".7rem",
                            fontWeight: 600,
                          }}
                        >
                          {item.beneficiary_id}
                        </span>
                      ) : (
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() => handleAddBeneficiary(item)}
                          disabled={beneficiaryUpdatingRows.length > 0}
                        >
                          Add
                        </Button>
                      )}
                    </td>
                    <td className="text-center align-middle" style={{ fontSize: ".9rem" }}>
                      {item.created_on || "-"}
                    </td>
                    <td className="text-center align-middle">
                      {getStatusBadge(item.status)}
                    </td>
                    <td className="text-center align-middle">
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        disabled={statusUpdatingRows.includes(
                          item.volunteer_id || item.volunteer_code
                        )}
                        onClick={() => openStatusModal(item)}
                        style={{
                          border: "1px solid #d8cec0",
                          fontWeight: 700,
                        }}
                      >
                        Change Status
                      </Button>
                    </td>
                    <td className="text-center align-middle">
                      {item.status === "N" ? (
                        <Button
                          size="sm"
                          onClick={() => handleProcessAll(item)}
                          disabled={
                            item.hold_status === "Y" ||
                            clickedRows.includes(item.volunteer_id || item.volunteer_code)
                          }
                        >
                          Process
                        </Button>
                      ) : (
                        <Button size="sm" disabled>
                          Processed
                        </Button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-4 text-muted">
                    No Packky settlement data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Modal show={statusModal.show} onHide={closeStatusModal} centered>
        <Form onSubmit={handleSettlementStatusChange}>
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "1rem", fontWeight: 700 }}>
              Change Settlement Status
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <div style={{ fontWeight: 700, color: "#24313f" }}>
                {statusModal.item?.bank_holder_name || "-"}
              </div>
         
            </div>

            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: ".85rem", fontWeight: 700 }}>
                Status
              </Form.Label>
              <Form.Control
                as="select"
                size="sm"
                value={statusModal.status}
                onChange={(event) =>
                  setStatusModal((prev) => ({
                    ...prev,
                    status: event.target.value,
                  }))
                }
              >
                <option value="N">N</option>
                <option value="Y">Y</option>
              </Form.Control>
            </Form.Group>

            <Form.Group>
              <Form.Label style={{ fontSize: ".85rem", fontWeight: 700 }}>
                Remarks
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={statusModal.remarks}
                onChange={(event) =>
                  setStatusModal((prev) => ({
                    ...prev,
                    remarks: event.target.value,
                  }))
                }
                placeholder="Enter remarks"
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light" size="sm" onClick={closeStatusModal}>
              Cancel
            </Button>
            <Button
              type="submit"
              size="sm"
              disabled={
                !statusModal.remarks.trim() ||
                statusModal.status === statusModal.item?.status ||
                statusUpdatingRows.includes(
                  statusModal.item?.volunteer_id || statusModal.item?.volunteer_code
                )
              }
            >
              Update Status
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Packkysettleamountwidgetvolunteer;
